import { render, staticRenderFns } from "./EmissionSourcesTable.vue?vue&type=template&id=83e02624&scoped=true"
import script from "./EmissionSourcesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmissionSourcesTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmissionSourcesTable.vue?vue&type=style&index=0&id=83e02624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e02624",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxTextField: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/TextField.vue').default,ImpactGoalEditEmissionSourceComparativeScenarioForm: require('/home/runner/work/assessment-service/assessment-service/frontend/components/impact-goal/edit/EmissionSourceComparativeScenarioForm.vue').default,ImpactGoalEditEmissionSourceYourSolutionForm: require('/home/runner/work/assessment-service/assessment-service/frontend/components/impact-goal/edit/EmissionSourceYourSolutionForm.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default})
